module.exports = __webpack_public_path__ + "static/media/icon_gender_select.ff0fb2f5.svg";